module.exports = __webpack_public_path__ + "static/media/view6.cbb750ec.jpg";